import { Pagination } from '@store/common/pagination.model';
import { TableFilter, TableFilterType } from '@store/common/tableFilter.model';
import { UserLight } from '@store/settings/users';
import { Waste } from '@store/settings/wasteFamilies';
import { SuppliersUnit } from '@store/suppliers/units/suppliers-units.model';
import { Container } from 'react-dom';
import { AuditDetails } from '../audit-details/audits-details.model';
import { AuditOfferResponseDto } from '../audit-offer/audit-offer.model';
import { AuditProposalSuppliers } from './audit-proposal-suppliers/audit-proposal-suppliers.model';

export enum StatusActivity {
  SENT = 'SENT',
  ANSWERED = 'ANSWERED',
  VALIDATED = 'VALIDATED',
}

export interface AuditOfferLightDto {
  id:	number;
  container:	string;
  waste:	string;
  unitPriceInCents:	number;
  family: string;
}


export interface AuditProposalResponseDto {
  id: number;
  audit: AuditResponseDto;
  expireAt: string;
  createdAt: string;
  name: string;
  supplierUnits: SuppliersUnit[];
  auditProposalSuppliers: AuditProposalSuppliers[];
}

export interface ProposalOffer extends AuditOfferResponseDto {
  container: Container;
  waste : Waste;
  isSelected: boolean;
}

export interface AuditOffer {
  auditId:	number;
  initialCostInCents:	number;
}

export interface CreateAuditOfferFollowUp {
  auditOffers: AuditOffer[];
  supplierOrganisationUnitIds: number[];
  expiresAt: string;
  proposalName: string;
}

export interface AuditResponseDto extends AuditDetails {
  user: UserLight;
}

export interface ProposalSupplierActivities {
  date:  string;
  auditProposalSupplierId: number;
  auditProposalName: string;
  supplierOrganisationUnitId:	number;
  supplierOrganisationUnitName:  string;
  type: StatusActivity;
}

export interface AuditOfferFollowUpResponseDto {
  id: number;
  proposalName: string;
  expiresAt: string;
  createdAt: string;
  supplierUnits: SuppliersUnit[];
  audit: AuditResponseDto;
  name: string;
}

export interface AuditOfferFollowUpFilters {
  search: string;
  tableFilters: TableFilter[];
}

export namespace AuditOfferFollowUpFilters {
  export const initTableFilters = () => TableFilterType.initTableFilters([
    TableFilterType.ORGANISATION_TYPOLOGY,
    TableFilterType.ORGANISATION_DOMAIN,
  ]);
}

export interface AuditOfferFollowUpPagination extends Pagination {
  data: AuditOfferFollowUp[];
}

export interface AuditOfferFollowUp {
  id: number;
  audit: AuditDetails;
  expireAt: string;
  createdAt: string;
  name: string;
  supplierUnits: SuppliersUnit[];
}

export interface AuditOfferContainerFollowUp {
  id: number;
  audit: AuditDetails;
  partner : string;
  expireAt: string;
  createdAt: string;
  emissionDate: Date;
  name: string;
  supplierUnits: SuppliersUnit[];
}